export const mockComment = {
  status: 0,
  blog_id: 0,
  user_id: 3, // Default user ID
  title: "",
  text: "",
};
